/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComparisonStatus } from './ComparisonStatus';
import {
    ComparisonStatusFromJSON,
    ComparisonStatusFromJSONTyped,
    ComparisonStatusToJSON,
    ComparisonStatusToJSONTyped,
} from './ComparisonStatus';
import type { ComparisonStatisticsRoomMatchesByStatus } from './ComparisonStatisticsRoomMatchesByStatus';
import {
    ComparisonStatisticsRoomMatchesByStatusFromJSON,
    ComparisonStatisticsRoomMatchesByStatusFromJSONTyped,
    ComparisonStatisticsRoomMatchesByStatusToJSON,
    ComparisonStatisticsRoomMatchesByStatusToJSONTyped,
} from './ComparisonStatisticsRoomMatchesByStatus';
import type { ComparisonStatisticsLineItemMatchesByStatus } from './ComparisonStatisticsLineItemMatchesByStatus';
import {
    ComparisonStatisticsLineItemMatchesByStatusFromJSON,
    ComparisonStatisticsLineItemMatchesByStatusFromJSONTyped,
    ComparisonStatisticsLineItemMatchesByStatusToJSON,
    ComparisonStatisticsLineItemMatchesByStatusToJSONTyped,
} from './ComparisonStatisticsLineItemMatchesByStatus';

/**
 * Detailed statistics for a comparison including money found and time tracking
 * @export
 * @interface ComparisonStatistics
 */
export interface ComparisonStatistics {
    /**
     * ID of the comparison
     * @type {number}
     * @memberof ComparisonStatistics
     */
    comparisonId: number;
    /**
     * 
     * @type {ComparisonStatus}
     * @memberof ComparisonStatistics
     */
    status: ComparisonStatus;
    /**
     * Total amount from insurer estimate in cents
     * @type {number}
     * @memberof ComparisonStatistics
     */
    insurerTotalCents: number;
    /**
     * Total amount from contractor estimate in cents
     * @type {number}
     * @memberof ComparisonStatistics
     */
    contractorTotalCents: number;
    /**
     * Difference between contractor and insurer (contractor - insurer) in cents
     * @type {number}
     * @memberof ComparisonStatistics
     */
    differenceCents: number;
    /**
     * Percentage difference relative to insurer total
     * @type {number}
     * @memberof ComparisonStatistics
     */
    differencePercent: number;
    /**
     * Money found (positive difference) in cents
     * @type {number}
     * @memberof ComparisonStatistics
     */
    moneyFound?: number;
    /**
     * Money found formatted as currency string
     * @type {string}
     * @memberof ComparisonStatistics
     */
    moneyFoundFormatted?: string;
    /**
     * Total number of line items in insurer estimate
     * @type {number}
     * @memberof ComparisonStatistics
     */
    totalInsurerLineItems: number;
    /**
     * Total number of line items in contractor estimate
     * @type {number}
     * @memberof ComparisonStatistics
     */
    totalContractorLineItems: number;
    /**
     * Number of matched insurer line items
     * @type {number}
     * @memberof ComparisonStatistics
     */
    matchedInsurerItems?: number;
    /**
     * Number of matched contractor line items
     * @type {number}
     * @memberof ComparisonStatistics
     */
    matchedContractorItems?: number;
    /**
     * Number of unmatched insurer line items
     * @type {number}
     * @memberof ComparisonStatistics
     */
    unmatchedInsurerCount?: number;
    /**
     * Number of unmatched contractor line items
     * @type {number}
     * @memberof ComparisonStatistics
     */
    unmatchedContractorCount?: number;
    /**
     * Total RCV value of unmatched contractor line items in cents (for supplement analysis)
     * @type {number}
     * @memberof ComparisonStatistics
     */
    unmatchedContractorTotalCents?: number;
    /**
     * Total number of line item match groups
     * @type {number}
     * @memberof ComparisonStatistics
     */
    lineItemMatchCount: number;
    /**
     * 
     * @type {ComparisonStatisticsLineItemMatchesByStatus}
     * @memberof ComparisonStatistics
     */
    lineItemMatchesByStatus?: ComparisonStatisticsLineItemMatchesByStatus;
    /**
     * Total number of room match groups
     * @type {number}
     * @memberof ComparisonStatistics
     */
    roomMatchCount: number;
    /**
     * 
     * @type {ComparisonStatisticsRoomMatchesByStatus}
     * @memberof ComparisonStatistics
     */
    roomMatchesByStatus?: ComparisonStatisticsRoomMatchesByStatus;
    /**
     * Processing time in milliseconds (if available)
     * @type {number}
     * @memberof ComparisonStatistics
     */
    processingTimeMs?: number | null;
    /**
     * When the comparison was created
     * @type {Date}
     * @memberof ComparisonStatistics
     */
    createdAt: Date;
    /**
     * When the comparison was last updated
     * @type {Date}
     * @memberof ComparisonStatistics
     */
    updatedAt: Date;
    /**
     * When the comparison was completed (if completed)
     * @type {Date}
     * @memberof ComparisonStatistics
     */
    completedAt?: Date | null;
    /**
     * Percentage of insurer line items that are matched
     * @type {number}
     * @memberof ComparisonStatistics
     */
    matchRate: number;
}



/**
 * Check if a given object implements the ComparisonStatistics interface.
 */
export function instanceOfComparisonStatistics(value: object): value is ComparisonStatistics {
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('insurerTotalCents' in value) || value['insurerTotalCents'] === undefined) return false;
    if (!('contractorTotalCents' in value) || value['contractorTotalCents'] === undefined) return false;
    if (!('differenceCents' in value) || value['differenceCents'] === undefined) return false;
    if (!('differencePercent' in value) || value['differencePercent'] === undefined) return false;
    if (!('totalInsurerLineItems' in value) || value['totalInsurerLineItems'] === undefined) return false;
    if (!('totalContractorLineItems' in value) || value['totalContractorLineItems'] === undefined) return false;
    if (!('lineItemMatchCount' in value) || value['lineItemMatchCount'] === undefined) return false;
    if (!('roomMatchCount' in value) || value['roomMatchCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('matchRate' in value) || value['matchRate'] === undefined) return false;
    return true;
}

export function ComparisonStatisticsFromJSON(json: any): ComparisonStatistics {
    return ComparisonStatisticsFromJSONTyped(json, false);
}

export function ComparisonStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComparisonStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'comparisonId': json['comparisonId'],
        'status': ComparisonStatusFromJSON(json['status']),
        'insurerTotalCents': json['insurerTotalCents'],
        'contractorTotalCents': json['contractorTotalCents'],
        'differenceCents': json['differenceCents'],
        'differencePercent': json['differencePercent'],
        'moneyFound': json['moneyFound'] == null ? undefined : json['moneyFound'],
        'moneyFoundFormatted': json['moneyFoundFormatted'] == null ? undefined : json['moneyFoundFormatted'],
        'totalInsurerLineItems': json['totalInsurerLineItems'],
        'totalContractorLineItems': json['totalContractorLineItems'],
        'matchedInsurerItems': json['matchedInsurerItems'] == null ? undefined : json['matchedInsurerItems'],
        'matchedContractorItems': json['matchedContractorItems'] == null ? undefined : json['matchedContractorItems'],
        'unmatchedInsurerCount': json['unmatchedInsurerCount'] == null ? undefined : json['unmatchedInsurerCount'],
        'unmatchedContractorCount': json['unmatchedContractorCount'] == null ? undefined : json['unmatchedContractorCount'],
        'unmatchedContractorTotalCents': json['unmatchedContractorTotalCents'] == null ? undefined : json['unmatchedContractorTotalCents'],
        'lineItemMatchCount': json['lineItemMatchCount'],
        'lineItemMatchesByStatus': json['lineItemMatchesByStatus'] == null ? undefined : ComparisonStatisticsLineItemMatchesByStatusFromJSON(json['lineItemMatchesByStatus']),
        'roomMatchCount': json['roomMatchCount'],
        'roomMatchesByStatus': json['roomMatchesByStatus'] == null ? undefined : ComparisonStatisticsRoomMatchesByStatusFromJSON(json['roomMatchesByStatus']),
        'processingTimeMs': json['processingTimeMs'] == null ? undefined : json['processingTimeMs'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'matchRate': json['matchRate'],
    };
}

export function ComparisonStatisticsToJSON(json: any): ComparisonStatistics {
    return ComparisonStatisticsToJSONTyped(json, false);
}

export function ComparisonStatisticsToJSONTyped(value?: ComparisonStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comparisonId': value['comparisonId'],
        'status': ComparisonStatusToJSON(value['status']),
        'insurerTotalCents': value['insurerTotalCents'],
        'contractorTotalCents': value['contractorTotalCents'],
        'differenceCents': value['differenceCents'],
        'differencePercent': value['differencePercent'],
        'moneyFound': value['moneyFound'],
        'moneyFoundFormatted': value['moneyFoundFormatted'],
        'totalInsurerLineItems': value['totalInsurerLineItems'],
        'totalContractorLineItems': value['totalContractorLineItems'],
        'matchedInsurerItems': value['matchedInsurerItems'],
        'matchedContractorItems': value['matchedContractorItems'],
        'unmatchedInsurerCount': value['unmatchedInsurerCount'],
        'unmatchedContractorCount': value['unmatchedContractorCount'],
        'unmatchedContractorTotalCents': value['unmatchedContractorTotalCents'],
        'lineItemMatchCount': value['lineItemMatchCount'],
        'lineItemMatchesByStatus': ComparisonStatisticsLineItemMatchesByStatusToJSON(value['lineItemMatchesByStatus']),
        'roomMatchCount': value['roomMatchCount'],
        'roomMatchesByStatus': ComparisonStatisticsRoomMatchesByStatusToJSON(value['roomMatchesByStatus']),
        'processingTimeMs': value['processingTimeMs'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt'] as any).toISOString()),
        'matchRate': value['matchRate'],
    };
}

